import { render } from "./odds.vue?vue&type=template&id=36e97a90&scoped=true"
import script from "./odds.vue?vue&type=script&lang=js"
export * from "./odds.vue?vue&type=script&lang=js"

import "./odds.vue?vue&type=style&index=0&id=36e97a90&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e97a90"]])

export default __exports__